module.exports = __webpack_public_path__ + "static/media/logo.e2688819.png";